import { MutationTree } from "vuex";
import { InfoCandidate } from "./types";

export const mutations: MutationTree<InfoCandidate> = {
  CANDIDATE_FULLFILED(state, payload: []) {
    state.data = payload;
  },
  RESET_CANDIDATE(state) {
    state.data = [];
  },
  CANDIDATE_REJECTED(state, payload: string) {
    state.error = payload;
  },
};
